import { Box } from '@mui/material';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';

import UpIcon from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';

import GameService from '../../../../../services/game.service';
import { gamePlayerCreateCommand } from '../../../components/utilities';
import { XmlDataFilterGamePlayer } from '../../../components/xmldata';
import { ActionData, isGoalTag } from '../../../components/common';
import GamePlayerTagList from '../../../games/tabs/players/tagList';
import GameTagControlSection from '../../../games/tabs/overview/tagControlSection';
import GameTagMenu from '../../../games/tabs/overview/tagMenu';
import GameOverviewHeader from '../../../games/tabs/overview/header';
import GamePlayerTagButtonList from '../../../games/tabs/players/tagButtonList';
import GamePlayerLogoList from '../../../games/tabs/players/playerLogoList';
import GameExportToEdits from '../../../games/tabs/overview/exportEdits';
import { getPeriod } from '../../../games/tabs/overview/tagListItem';
import GameVideoPlayer from '../../../games/gameVideoPlayer';

import Alert from '../../../../../common/alert';

const OpponentPlayers = ({ game, t }) => {
    const [showAlert, setShowAlert] = useState(false);
    const [showResultAlert, setShowResultAlert] = useState(false);
    const [downState, setDownState] = useState('');
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);
    useEffect(() => {
        if (showResultAlert) {
            const timer = setTimeout(() => {
                setShowResultAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showResultAlert]);

    const [curTeamTagIdx, setCurTeamTagIdx] = useState(0);
    const [videoData, setVideoData] = useReducer((old, action) => ({ ...old, ...action }), {
        idx: 0,
        autoPlay: true,
        tagList: [],
        videoPlay: true,
        click: false
    });
    const [values, setValues] = useState({
        isOur: true,
        expandButtons: true,
        playList: [],
        selectAll: false,
        clickEventName: ''
    });
    const [gameTime, setGameTime] = useState({
        period: 'H1',
        time: 0,
        video_url: '',
        home_team_goals: 0,
        away_team_goals: 0,
        home_team_image: '',
        away_team_image: ''
    });
    const [tagIndex, setTagIndex] = useState({});
    const [loadData, setLoadData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkArray, setCheckArray] = useState([]);
    const [exportHudl, setExportHudl] = useState(false);
    const [playerTagList, setPlayerTagList] = useState([]);
    const [playerIds, setPlayerIds] = useState([]);
    const [exportEditOpen, setExportEditOpen] = useState(false);

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const { user: currentUser } = useSelector((state) => state.auth);

    const handleChangeTeam = (flag) => {
        setValues({ ...values, isOur: flag, playList: [] });
        setVideoData({ ...videoData, idx: 0, tagList: [] });
        setTagIndex({});
    };

    const handleShowPopover = (idx) => (e) => {
        setTagIndex(idx);
        setGameTime({ ...gameTime, period: 'H1', time: 0, home_team_goals: 0, away_team_goals: 0, home_team_image: '', away_team_image: '' });
        setMenuAnchorEl(e.currentTarget);
    };

    const handleClickView = () => {
        setMenuAnchorEl(null);
        setValues({ ...values, clickEventName: '' });
        setLoadData(true);
    };

    const handleClickHudlFromButton = () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);

        setPlayerTagList(newList);
        setExportHudl(true);
    };

    const handleClickHudlFromMenu = () => {
        setMenuAnchorEl(null);

        if (values.playList.length === 0) {
            setValues({ ...values, clickEventName: 'sportcode' });
            setLoadData(true);
        } else {
            setPlayerTagList(values.playList);
            setExportHudl(true);
        }
    };

    const handleClickRenderFromMenu = async () => {
        setMenuAnchorEl(null);

        if (values.playList.length === 0) {
            setValues({ ...values, clickEventName: 'render' });
            setLoadData(true);
        } else {
            setShowAlert(true);
            const result = await gamePlayerCreateCommand(values.playList, tagIndex.name, [game], [game.id]);

            setShowResultAlert(true);
            setDownState(result);
        }
    };

    const handleClickRenderFromButton = async () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);
        setShowAlert(true);
        const result = await gamePlayerCreateCommand(newList, tagIndex.name, [game], [game.id]);

        setShowResultAlert(true);
        setDownState(result);
    };

    const handleClickEditsFromButton = () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);

        setPlayerTagList(newList);
        setExportEditOpen(true);
    };

    const handleClickEditsFromMenu = () => {
        setMenuAnchorEl(null);

        if (values.playList.length === 0) {
            setValues({ ...values, clickEventName: 'my_edits' });
            setLoadData(true);
        } else {
            setPlayerTagList(values.playList);
            setExportEditOpen(true);
        }
    };

    const handleExpandButtons = () => {
        setValues({ ...values, expandButtons: !values.expandButtons });
    };

    const handleShowVideo = (index) => {
        setCurTeamTagIdx(index);
        setVideoData({ ...videoData, idx: index, click: !videoData.click });
    };

    const handleCheckChange = (idx) => (e) => {
        setCheckArray({ ...checkArray, [idx]: e.target.checked });
    };

    const getTime = (time, delta) => {
        const items = time.split(':');
        const changedTime = parseInt(items[0]) * 3600 + parseInt(items[1]) * 60 + parseInt(items[2]) + delta;
        let hour = Math.floor(changedTime / 3600);
        let minute = Math.floor((changedTime - hour * 3600) / 60);
        let second = changedTime - hour * 3600 - minute * 60;

        if (hour < 10) hour = '0' + hour;
        if (minute < 10) minute = '0' + minute;
        if (second < 10) second = '0' + second;

        return hour + ':' + minute + ':' + second;
    };

    const handleChangeTime = (index, isStart, direction) => {
        let array = [...values.playList];
        let data = [...videoData.tagList];

        if (isStart) {
            const changed = getTime(array[index].player_tag_start_time, direction);

            array[index].player_tag_start_time = changed;
            data[index].start_time = changed;
        } else {
            const changed = getTime(array[index].player_tag_end_time, direction);

            array[index].player_tag_end_time = changed;
            data[index].end_time = changed;
        }

        setValues({ ...values, playList: array });
        setVideoData({ ...videoData, tagList: data });
    };

    const changeGameTime = (array, idx) => {
        setGameTime({
            ...gameTime,
            period: getPeriod(array[idx].period),
            time: array[idx].time_in_game,
            home_team_goals: array[idx].home_team_goals ?? undefined,
            away_team_goals: array[idx].away_team_goals ?? undefined,
            home_team_image: array[idx].home_team_logo ?? undefined,
            away_team_image: array[idx].away_team_logo ?? undefined
        });
    };

    const getPlayTagList = async (func) => {
        func.then(async (res) => {
            setLoading(false);
            setLoadData(false);

            // Goal clips are shots only; assists are also tagged result=Goal, so filter them out.
            if (tagIndex?.id === 'Goal') res = res.filter(isGoalTag);

            if (values.clickEventName === 'render') {
                setShowAlert(true);
                const result = await gamePlayerCreateCommand(res, tagIndex.name, [game], [game.id]);

                setShowResultAlert(true);
                setDownState(result);
            } else if (values.clickEventName === 'sportcode') {
                setPlayerTagList(res);
                setExportHudl(true);
            } else if (values.clickEventName === 'my_edits') {
                setPlayerTagList(res);
                setExportEditOpen(true);
            } else {
                // Normalize field names (API may return singular or plural versions)
                // Also compute time_in_game from player_tag_start_time if not present
                const normalizedRes = res.map((item) => {
                    let timeInGame = item.time_in_game;
                    // Convert to minutes if undefined or if it's a timestamp string (contains ":")
                    if ((timeInGame === undefined || (typeof timeInGame === 'string' && timeInGame.includes(':'))) && item.player_tag_start_time) {
                        // Extract minutes from "HH:MM:SS" format
                        const parts = item.player_tag_start_time.split(':');
                        if (parts.length >= 2) {
                            timeInGame = parseInt(parts[0]) * 60 + parseInt(parts[1]);
                        }
                    }
                    return {
                        ...item,
                        time_in_game: timeInGame,
                        player_names: item.player_names || item.player_name || '',
                        action_names: item.action_names || item.action_name || '',
                        action_type_names: item.action_type_names || item.action_type_name || '',
                        action_result_names: item.action_result_names || item.action_result_name || ''
                    };
                });
                setVideoData({
                    ...videoData,
                    idx: 0,
                    tagList: normalizedRes.map((item) => {
                        return {
                            start_time: item.player_tag_start_time,
                            end_time: item.player_tag_end_time,
                            name: `${item.player_names} - ${item.action_names} - ${item.action_type_names} - ${item.action_result_names}`,
                            period: item.period,
                            time_in_game: item.time_in_game,
                            home_team_goals: item.home_team_goals,
                            away_team_goals: item.away_team_goals,
                            home_team_logo: item.home_team_logo,
                            away_team_logo: item.away_team_logo
                        };
                    })
                });
                setValues({ ...values, playList: normalizedRes });
                setCheckArray([]);
                res.map((item, index) => {
                    setCheckArray((oldRows) => [...oldRows, false]);
                });

                if (res.length > 0) {
                    changeGameTime(res, 0);
                } else {
                    setDownState(t('No clips found for this action'));
                    setShowResultAlert(true);
                }
            }
        });
    };

    useEffect(() => {
        if (loadData) {
            setLoading(true);
            setValues({ ...values, playList: [] });
            setVideoData({ ...videoData, tagList: [] });
            getPlayTagList(
                GameService.getGamePlayerTags(
                    currentUser.id,
                    values.isOur ? game.home_team_id : game.away_team_id,
                    playerIds.length === 0 ? null : playerIds.join(','),
                    `${game.id}`,
                    ActionData[tagIndex.id].action_id,
                    ActionData[tagIndex.id].action_type_id,
                    ActionData[tagIndex.id].action_result_id,
                    null,
                    null,
                    null,
                    null,
                    null
                )
            );
        }
    }, [tagIndex, loadData]);

    useEffect(() => {
        setCheckArray([]);
        values.playList.map((item, index) => {
            setCheckArray((oldRows) => [...oldRows, values.selectAll]);
        });
    }, [values.selectAll]);

    useEffect(() => {
        if (values.playList.length > 0) changeGameTime(values.playList, curTeamTagIdx);
    }, [curTeamTagIdx]);

    useEffect(() => {
        setGameTime({ ...gameTime, video_url: game.video_url });
    }, []);

    return (
        <Box sx={{ width: '100%', background: '#ffffff', flex: 1, overflowY: 'auto', display: 'flex' }}>
            {showAlert && <Alert text={'Render started!'} />}
            {showResultAlert && <Alert text={downState} />}
            <Box sx={{ display: 'flex', flexDirection: 'column', padding: '24px 10px' }}>
                <GameOverviewHeader isOur={values.isOur} ourname={game.home_team_name} enemyname={game.away_team_name} onChangeTeam={handleChangeTeam} mb="8px" />
                <GamePlayerLogoList t={t} game={game} teamId={game.home_team_id} opponent={game.away_team_id} our={values.isOur} setIds={setPlayerIds} isEdit={false} />
                {values.expandButtons && <GamePlayerTagButtonList t={t} selectedTag={tagIndex} onShow={handleShowPopover} />}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ flex: 1, height: '1px', background: 'black' }} />
                    <Box sx={{ 'svg path': { fill: 'black' }, cursor: 'pointer' }} onClick={handleExpandButtons}>
                        <UpIcon sx={{ transform: values.expandButtons ? '' : 'rotate(180deg)' }} />
                    </Box>
                </Box>
                <GameTagMenu
                    t={t}
                    anchor={menuAnchorEl}
                    onClose={() => setMenuAnchorEl(null)}
                    onView={handleClickView}
                    onHudl={handleClickHudlFromMenu}
                    onRender={handleClickRenderFromMenu}
                    onEdits={handleClickEditsFromMenu}
                />
                {values.playList.length > 0 && (
                    <GameTagControlSection
                        t={t}
                        clipCount={values.playList.length}
                        isSelectAll={values.selectAll}
                        onAll={(e) => setValues({ ...values, selectAll: e.target.checked })}
                        onHudl={handleClickHudlFromButton}
                        onRender={handleClickRenderFromButton}
                        onEdits={handleClickEditsFromButton}
                    />
                )}
                <GamePlayerTagList
                    t={t}
                    isLoading={loading}
                    expand={values.expandButtons}
                    tagList={values.playList}
                    curTagListIdx={curTeamTagIdx}
                    checkArr={checkArray}
                    onChecked={handleCheckChange}
                    onVideo={handleShowVideo}
                    onTime={handleChangeTime}
                />
            </Box>
            <GameVideoPlayer t={t} videoData={videoData} game={gameTime} onChangeClip={(idx) => setCurTeamTagIdx(idx)} drawOpen={true} />
            {exportHudl && <XmlDataFilterGamePlayer game={game} tagList={playerTagList} isOur={values.isOur} tag_name={tagIndex.name} setExportXML={setExportHudl} />}
            <GameExportToEdits t={t} open={exportEditOpen} onClose={() => setExportEditOpen(false)} tagList={playerTagList} isTeams={false} />
        </Box>
    );
};

export default OpponentPlayers;
